"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../../constants");
const NotificationMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "22px",
  height: "22px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  d: "M14.7133732,21.4999999 C14.2875858,22.6951024 13.1560595,23.4931613 11.8873732,23.4931613 C10.618687,23.4931613 9.48716069,22.6951024 9.06137324,21.4999999 L9.06137324,21.4999999 Z M11.8873732,0 C16.0295089,0 19.3873732,3.35786435 19.3873732,7.5 L19.3873732,7.5 L19.3873732,12.496962 C19.4165611,14.8766976 20.0821406,17.205274 21.3150513,19.2409798 L21.3150513,19.2409798 L21.7747465,20 L2,20 L2.45969515,19.2409798 C3.69312089,17.2044236 4.35874131,14.8747521 4.38737324,12.5 L4.38737324,12.5 L4.38737324,7.5 C4.38737324,3.35786435 7.74523762,0 11.8873732,0 Z M11.8873732,1 C8.29752237,1 5.38737324,3.9101491 5.38737324,7.5 L5.38737324,7.5 L5.387337,12.5060203 C5.36002473,14.77419 4.79491935,16.9992141 3.74376153,19 L3.74376153,19 L20.030985,19 C18.9798271,16.9992141 18.4147217,14.77419 18.3874095,12.5060203 L18.3874095,12.5060203 L18.3873732,7.5 C18.3873732,3.9101491 15.4772241,1 11.8873732,1 Z"
}));
const NotificationPrizm = ({
  fill
}) => _react.default.createElement("svg", {
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  fill: fill
}, _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(7.000000, 5.000000)"
}, _react.default.createElement("path", {
  d: "M8.961,2 C10.677,2 12,2.456 12.893,3.356 C14.399,4.874 14.398,7.269 14.398,7.323 L14.398,12.822 C14.398,13.279 14.516,13.721 14.738,14.108 L15.382,16.012 L2.627,16.012 L3.356,13.923 C3.567,13.542 3.68,13.109 3.68,12.666 L3.68,7.534 L3.678,7.493 C3.677,7.468 3.643,4.911 5.14,3.352 C6.013,2.442 7.263,2 8.961,2 M8.961,0 C16.2079091,0 16.3960847,6.67240289 16.3982186,7.27898497 L16.398,12.822 C16.398,12.969 16.451,13.11 16.547,13.214 L16.547,13.214 L17.85,17.066 C18.171,17.415 17.943,18.012 17.489,18.012 L17.489,18.012 L13.1622351,18.0126017 C13.0143195,20.2367396 11.2045054,22 9,22 C6.79549461,22 4.98568052,20.2367396 4.83776488,18.0126017 L0.511,18.012 C0.066,18.012 -0.165,17.437 0.136,17.082 L0.136,17.082 L1.544,13.043 C1.632,12.94 1.68,12.806 1.68,12.666 L1.68,12.666 L1.68,7.575 C1.68,7.575 1.6793595,7.55934917 1.67884964,7.52947032 L1.6784831,7.3985725 C1.68893388,6.26033058 2.06009091,0 8.961,0 Z M11.1539602,18.0128459 L6.84603984,18.0128459 C6.98412599,19.1329048 7.89797935,20 9,20 C10.1020207,20 11.015874,19.1329048 11.1539602,18.0128459 Z"
}))));
const Notification = ({
  theme = {},
  fill = '#fff',
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(NotificationMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(NotificationPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(Notification);